<template>
  <div>
    <v-container fluid grid-list-xl ref="groupForm">
      <template v-if="can('edit', 'tournament', tournament)">
        <v-layout wrap>
          <v-flex xs12 ml-3>
            <span
              class="title"
            >{{localGroup._id ? getName(localGroup.name) : $t('newModel', {field: $tc('group')})}}</span>
          </v-flex>
          <v-flex d-flex lg12 md12 sm12 xs12>
            <v-flex d-flex lg12 md12 sm12 xs12 id="tabLanguages">
              <v-tabs color="primary" fixed-tabs ref="tablanguage">
                <v-tab
                  :key="index + 100"
                  v-for="(lang, index) in localGroup.name"
                >{{lang.language.name}}</v-tab>
                <v-tab-item :key="index + 200" v-for="(lang, index) in localGroup.name">
                  <v-container fluid grid-list-xl>
                    <v-layout wrap>
                      <v-flex d-flex lg12 md12 sm12 xs12>
                        <IgTextField
                          :disabled="!Edit"
                          :rules="valid ? [] : [v => !lang.language.required || rules.vacio(v, 'name')]"
                          :status="true"
                          :label="$t('name')"
                          v-model="lang.text"
                        ></IgTextField>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-tab-item>
              </v-tabs>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex d-flex lg4 md4 sm6 xs12>
            <v-select
              :disabled="!!localGroup._id"
              :rules="valid ? [] : [v => rules.vacio(v,'phase')]"
              :items="selectPhases"
              :label="$t('select', {field: $tc('phase')})"
              v-model="localGroup.phase"
            ></v-select>
          </v-flex>
          <v-flex d-flex lg4 md4 sm6 xs12>
            <v-autocomplete
              clearable
              :items="selectPitches"
              :rules="valid ? [] : [v => rules.vacio(v,'pitch')]"
              :label="$t('select', {field: $tc('pitch')})"
              v-model="localGroup.pitch"
            ></v-autocomplete>
          </v-flex>
          <v-flex v-if="!isRandomMatches" d-flex lg4 md4 sm6 xs12>
            <v-autocomplete
              chips
              deletable-chips
              clearable
              multiple
              :items="selectMatches"
              :label="$t('select', {field: $tc('match',2)})"
              v-model="localGroup.matches"
              @change="searchMatch = ''"
              :search-input.sync="searchMatch"
            >
              <template v-slot:selection="data">
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="localGroup.matches.splice(localGroup.matches.indexOf(data.item.value), 1)"
                >{{ `${data.item.text} (${data.item.date})` }}</v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-tile-content>
                  <v-list-tile-title>{{data.item.text}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{data.item.date}}</v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 text-xs-right>
            <v-btn
              @click="()=> {localGroup = templateGroup(); valid = true}"
              small
              color="warning"
            >{{$t('reset')}}</v-btn>
            <v-btn @click="setGroup()" small :color="localGroup._id ? 'secondary' : 'success'">
              <span v-if="loading">
                <v-progress-circular :size="20" :width="3" color="#FFFFFF" indeterminate></v-progress-circular>
              </span>
              <span
                v-else
              >{{ localGroup._id ? $t('updateModel', {field: $tc('group')}) : $t('addField', {field: $tc('group')})}}</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <v-expansion-panel expand v-model="panel">
        <v-toolbar card color="white">
          <v-toolbar-title>{{$tc('phase',2)}}</v-toolbar-title>
        </v-toolbar>
        <v-expansion-panel-content v-for="(phase, index) in localPhases" :key="index + 20">
          <template v-slot:header>
            <div class="title">{{getName(phase.name)}}</div>
          </template>
          <v-card>
            <v-card-text>
              <div class="v-table__overflow">
                <table class="text-xs-center v-datatable v-table theme--light">
                  <thead>
                    <tr>
                      <th>{{$t('order')}}</th>
                      <th>{{$t('name')}}</th>
                      <th>{{$t('ifShowResults')}}</th>
                      <th>{{$t('ifRandomMatches')}}</th>
                      <th>{{$t('typePlayOff')}}</th>
                      <th>{{$t('toClass')}}</th>
                      <th>{{$t('matchesByParticipant')}}</th>
                      <th>{{$t('hours')}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="py-2">{{phase.order}}</td>
                      <td>{{getName(phase.name)}}</td>
                      <td>
                        <i
                          v-if="phase.showResults"
                          class="success--text icon material-icons subheading"
                        >check_circle</i>
                        <i v-else class="error--text icon material-icons subheading">cancel</i>
                      </td>
                      <td>
                        <i
                          v-if="phase.randomMatches"
                          class="success--text icon material-icons subheading"
                        >check_circle</i>
                        <i v-else class="error--text icon material-icons subheading">cancel</i>
                      </td>
                      <td>{{$t(phase.typePlayOff)}}</td>
                      <td>{{phase.typePlayOff === 'ranking' ? phase.toClass : '-'}}</td>
                      <td>{{phase.typePlayOff === 'ranking' ? phase.matchesByParticipant : '-'}}</td>
                      <td>{{phase.hours.join(', ')}}</td>
                      <hr />
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-card-text>
          </v-card>
          <v-divider></v-divider>
          <v-card>
            <v-card-text>
              <div
                class="title text-xs-center"
              >{{phase.groups.length ? $tc('group',2): $t('noGroup')}}</div>
              <div v-if="phase.groups.length" class="v-table__overflow">
                <table class="text-xs-center v-datatable v-table theme--light">
                  <thead>
                    <tr>
                      <th>{{$t('actions')}}</th>
                      <th>{{$t('order')}}</th>
                      <th>{{$t('name')}}</th>
                      <th>{{$t('location')}}</th>
                      <th>{{$tc('match',2)}}</th>
                    </tr>
                  </thead>
                  <draggable
                    v-model="phase.groups"
                    :handle="isMobile ? '.handle': '' "
                    tag="tbody"
                    @end="dragEnd(phase)"
                    :class="phase.groups.length > 1 ? 'draggable': ''"
                  >
                    <tr v-for="(group, index) in phase.groups" :key="index + 20">
                      <td class="handle">
                        <template v-if="can('edit', 'tournament', tournament)">
                          <v-btn v-if="localGroup._id != group._id" flat icon color="success" small>
                            <v-icon
                              class="icon material-icons"
                              @click="edit(group, phase)"
                              v-scroll-to="'#tabLanguages'"
                            >edit</v-icon>
                          </v-btn>
                          <v-btn v-else flat icon color="secondary" small class="ma-0">
                            <v-icon
                              class="icon material-icons"
                              @click="localGroup = Object.assign({}, templateGroup())"
                            >save</v-icon>
                          </v-btn>
                          <v-btn flat icon color="error" class="ma-0" small>
                            <v-icon
                              class="icon material-icons"
                              @click="ifDelete(phase, group)"
                            >delete</v-icon>
                          </v-btn>
                        </template>
                      </td>
                      <td class="py-2">{{group.order}}</td>
                      <td>{{getName(group.name)}}</td>
                      <td>{{formatPitch(group.pitch)}}</td>
                      <td>
                        <v-chip
                          dark
                          color="primary"
                          v-for="(match, index) in formatMatches(group.matches)"
                          :key="index + 220"
                        >{{match}}</v-chip>
                      </td>

                      <hr />
                    </tr>
                  </draggable>
                </table>
              </div>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-container>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">{{$t('confirmation')}}</v-card-title>
        <v-card-text
          v-html="$t('confirmADelete', {field: $tc('group'), name: getName(selected.name)})"
        ></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color flat="flat" @click="dialog = false">{{$t('cancel')}}</v-btn>

          <v-btn color="error" flat="flat" @click="deleteGroup()">
            <span v-if="loadingDelete">
              <v-progress-circular :size="20" :width="3" color="red" indeterminate></v-progress-circular>
            </span>
            <span v-else>{{$t('delete')}}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import rules from '../../../helpers/rules'
import queueToast from '../../../helpers/queueToast'
import { dateFormat, timeFormat } from '../../../helpers/dateHelper'
import draggable from 'vuedraggable'
import groups from '../../../store/modules/groups'

export default {
  name: 'tabGroups',
  mixins: [rules],
  components: { draggable },
  props: {
    Edit: {
      type: Boolean,
      required: true
    },
    stadiums: {
      type: Array,
      required: true,
      default: () => []
    },
    phases: {
      type: Array,
      required: true,
      default: () => []
    },
    type: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      searchMatch: '',
      localGroup: {},
      localPhases: [],
      selected: {},

      dialog: false,
      loading: false,
      loadingDelete: false,
      panel: [],
      valid: true
    }
  },
  watch: {
    stadiums: function(val) {
      if (val.length) this.setInitAulas(val)
    },
    tournament: function(val) {
      this.resetLocal()
    }
  },
  mounted() {
    this.resetLocal()
  },
  computed: {
    ...mapState({
      listPiches: state => state.pitches.listPortionPitches,
      listMatches: state => state.matches.list,
      listTeams: state => state.teams.listSelectTeams,
      listUsers: state => state.users.listSelectUsers,
      tournamentId: state => state.tournaments.idSelected,
      tournament: state => state.tournaments.selected
    }),
    isRandomMatches() {
      if (!this.localGroup.phase) return false
      const phase = this.localPhases.find(
        phase => phase._id === this.localGroup.phase
      )
      return phase && phase.randomMatches
    },
    selectPitches() {
      return this.listPiches.map(pitch => {
        return {
          text: pitch.name,
          value: pitch._id
        }
      })
    },
    selectMatches() {
      let results = this.listMatches.filter(
        match => match.active && match.tournamentId === this.tournament._id
      )
      if (this.type === 'teams') {
        return results.map(match => {
          let name = ''
          const homeTeam = this.listTeams.find(
            team => team.value === match.homeTeamId
          )
          name += `${homeTeam ? homeTeam.text : ' * '} - `
          const visitorTeam = this.listTeams.find(
            team => team.value === match.visitorTeamId
          )
          name += visitorTeam ? visitorTeam.text : ' * '

          return {
            value: match._id,
            text: name,
            date: `${dateFormat(match.date, false)} - ${match.time}`
          }
        })
      } else if (this.type === 'users' || this.type === 'usersTeams') {
        return results.map(match => {
          const user = this.listUsers.find(user => user.value === match.user)
          let name = user ? user.text : ' * '
          return {
            value: match._id,
            text: name,
            date: `${dateFormat(match.date, false)} - ${match.time}`
          }
        })
      } else return []
    },
    selectPhases() {
      return this.localPhases.map(phase => {
        return { text: this.getName(phase.name), value: phase._id }
      })
    }
  },
  methods: {
    ...mapActions({
      setInitAulas: 'pitches/setPortion',
      setCreateNew: 'groups/setCreateNew',
      setUpdate: 'groups/setUpdate',
      setDelete: 'groups/setDelete',
      setUpdatePhase: 'phases/setUpdate'
    }),
    templateGroup() {
      return {
        order: 0,
        name: this.setComplexLanguage(),
        pitch: '',
        matches: [],
        phase: ''
      }
    },
    edit(group, phase) {
      this.localGroup = { ...group, phase: phase._id }
      this.$refs.groupForm.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      })
    },
    isValidGroup() {
      const defaultLangId = this.$store.state.languages.defaultLangId
      const { name, phase } = this.localGroup
      let error = false
      let messages = []

      const spanishLang = name.find(lang => lang.langId === defaultLangId)
      if (!spanishLang || !spanishLang.text) {
        error = true
        messages.push(this.$t('error.nameSpanish'))
      }

      if (!phase) {
        error = true
        messages.push(this.$t('error.required', { field: this.$tc('phase') }))
      }

      if (error) {
        queueToast(messages)
        this.valid = false
        return false
      }
      return true
    },
    formatPitch(id) {
      if (!id) return '*'
      if (!this.selectPitches.length) return this.$t('messages.searching')
      let result = this.selectPitches.find(pitch => pitch.value === id)
      return result ? result.text : '*'
    },
    formatMatches(matches) {
      let results = this.selectMatches.filter(match =>
        matches.includes(match.value)
      )
      results = results.map(match => match.text || '*')
      return results
    },
    setGroup() {
      if (this.loading || !this.isValidGroup()) return

      let group = { ...this.localGroup }
      group.name = this.getComplexLanguage(group.name)
      const idPhase = group.phase
      delete group.phase

      let payload = {
        idTournament: this.tournament._id,
        idPhase,
        group
      }
      this.loading = true
      if (group._id) {
        this.setUpdate(payload).finally(() => (this.loading = false))
      } else {
        const groupPhase = this.localPhases.find(phase => phase._id === idPhase)
        if (groupPhase.groups.length) {
          const maxOrder = groupPhase.groups.reduce((prev, curr) =>
            prev.order > curr.order ? prev : curr
          ).order
          payload.group.order = maxOrder + 1
        } else payload.group.order = 1

        this.setCreateNew(payload).finally(() => (this.loading = false))
      }
    },
    deleteGroup() {
      if (this.loadingDelete) return
      let payload = { ...this.selected }
      delete payload.name
      this.loadingDelete = true
      this.setDelete(payload).finally(() => {
        this.loadingDelete = false
        this.dialog = false
        this.selected = {}
      })
    },
    ifDelete(phase, group) {
      this.selected = {
        idTournament: this.tournament._id,
        idPhase: phase._id,
        idGroup: group._id,
        name: group.name
      }

      this.dialog = true
    },
    dragEnd(phase) {
      if (!this.can('edit', 'tournament', this.tournament)) return
      const listGroups = phase.groups.map((group, index) => {
        let result = {
          ...group,
          order: index + 1
        }
        return result
      })
      let payload = {
        idTournament: this.tournament._id,
        phase: { _id: phase._id, groups: listGroups }
      }
      this.loading = true
      this.setUpdatePhase(payload).finally(() => (this.loading = false))
    },
    listEnd() {
      this.listGroups.forEach((item, index) => (item.order = index + 1))
    },
    resetLocal() {
      this.loading = false
      this.valid = true
      this.localGroup = Object.assign({}, this.templateGroup())
      this.panel = Array.from({ length: this.phases.length }, (v, i) => true)
      this.localPhases = this.phases.map(phase => {
        return {
          ...phase,
          name: this.setComplexLanguage(phase.name),
          groups: phase.groups.map(group => {
            return {
              ...group,
              name: this.setComplexLanguage(group.name)
            }
          })
        }
      })
    }
  }
}
</script>
